export class TimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "TimeoutError";
  }
}

export async function timeout<T>(action: () => T, ms: number) {
  const sleep = new Promise((_resolve, reject) => {
    setTimeout(() => {
      reject(new TimeoutError("timeout"));
    }, ms);
  });
  const result = await Promise.race([action(), sleep]);
  return result as T;
}
